export class FilterValues {
  [key: string]: string[]
};
